import { useTranslation } from 'react-i18next';
import styles from './PaywallPage.module.scss';
import { VdsButton } from '@volt/volt-extended-components-react';
import { ExternalUrl } from '@cas/config/links';
import VideoEmbed, { VideoEmbedProps } from '@customer/components/layout/video-embed/VideoEmbed';

interface PaywallPageProps {
  title: string;
  subtitle: string;
  description: string;
  videoProps: VideoEmbedProps;
}

export function PaywallPage({ title, subtitle, description, videoProps }: PaywallPageProps) {
  const { t } = useTranslation();

  return (
    <article className={styles.container}>
      <div className={styles.content}>
        <section className={styles.pitch}>
          <div className={styles.pitch__title}>{title}</div>
          <div className={styles.pitch__subtitle}>{subtitle}</div>
          <div className={styles.pitch__description}>{description}</div>
        </section>

        <section className={styles.demo}>
          <div className={styles.demo__title}>{t('PaywallDemoTitle')}</div>
          <VideoEmbed {...videoProps} />
        </section>

        <section className={styles.cta}>
          <div className={styles.cta__description}>{t('PaywallCtaDescription')}</div>
          <a
            className={styles.cta__link}
            href={ExternalUrl.MiningContact}
            target="_blank"
            rel="noopener noreferrer"
          >
            <VdsButton variant="primary" size="large" danger onClick={() => undefined}>
              {t(`PaywallCtaText`)}
            </VdsButton>
          </a>
        </section>
      </div>
    </article>
  );
}

export default PaywallPage;
